import { Button } from "@mui/material";
import Avatar, { AvatarProps } from "@mui/material/Avatar";
import Box, { BoxProps } from "@mui/material/Box";
import Link from "@mui/material/Link";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";
import { Alert } from "@mui/lab";

export const B = styled("b")({});

export const AlertCustom = styled(Alert)(() => ({
  width: "100% !important",
  height: "36px",
  borderRadius: "4px !important",
  fontWeight: 600,
  fontStyle: "normal",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#2A2A2B",
  gap: "8px",
}));

export const LoaderContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "20vh",
  width: "100%",
}));

export const ReachTitle = styled(Box)(() => ({
  fontSize: "10pt",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textAlign: "center",
}));

export const AvatarMobile = styled(Avatar)<AvatarProps>(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 25,
  height: 25,
}));

export const RootComment = styled(Box)<BoxProps>(({ theme }) => ({
  boxSizing: "border-box",
  wordBreak: "break-word",
  wordWrap: "break-word",
  whiteSpace: "normal",
  borderRadius: 18,
  backgroundColor: theme.palette.primary.main,
  color: "#FFF",
  width: "fit-content",
}));

export const CommentUsernameLink = styled(Link)(() => ({
  color: "#FFF !important",
  wordBreak: "break-word",
  wordWrap: "break-word",
  fontWeight: 600,
  lineHeight: "1.23080",
  fontSize: ".8125rem",
}));

export const Comment = styled("span")(() => ({
  wordBreak: "break-word",
  wordWrap: "break-word",
  maxWidth: "100%",
  fontWeight: 400,
  lineHeight: "1.3333",
  fontSize: ".9375rem",
}));

export const CommentList = styled("ul")(({ theme }) => ({
  marginLeft: 12,
  paddingTop: 3,
  minHeight: 15,
  fontSize: 12,
  lineHeight: "12px",
  color: theme.palette.primary.main,
  display: "flex",
}));

export const IPhoneContent = styled(Box)(({ theme }) => ({
  height: "65vh",
  width: "15vw",
  display: "inline-block",
  border: `5px solid ${theme.palette.primary.main}`,
  borderRadius: 25,
  boxShadow: "0 19px 38px rgb(0 0 0 / 31%), 0 15px 12px rgb(0 0 0 / 22%)",
  position: "relative",
  // overflowY: "overlay",
}));

export const TopBar = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  position: "absolute",
  left: "calc(22%)",
  top: -5,
  width: "56%",
  backgroundColor: theme.palette.primary.main,
  height: 12,
  borderRadius: "0px 0px 15px 15px",
}));

export const ContentTopBar = styled(Box)(({ theme }) => ({
  backgroundColor: "#000",
  height: 3,
  marginTop: 5,
  width: 30,
  borderRadius: "20%",
}));

export const ContentMobile = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.main,
  letterSpacing: -0.8,
  padding: "1vh 0vw",
}));

export const ButtonCancelCampaign = styled(Button)(() => ({
  height: "36px",
  gap: "10px",
  background: "#F2F3F5",
  borderRadius: "4px",
}));

export const TypographyButtonCancel = styled(Typography)(() => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: "20px",
  color: "#1E1F21",
}));

export const TypographyLearnMore = styled(Typography)(() => ({
  fontSize: "14px",
  width: "550px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textAlign: "justify",
}));
// export const styles = makeStyles(theme =>
//   createStyles({
//     content: { flexGrow: 1, height: '100%' },
//     button: { margin: theme.spacing(1) },
//     avatar: { backgroundColor: theme.palette.primary.main },
//     actions: { justifyContent: 'space-between' },
//     image: { width: '100%' },
//     phone: {
//       width: '100%',
//       '&:after': {
//         backgroundImage: `url(${imagePhone})`,
//         backgroundSize: 'contain',
//         backgroundRepeat: 'no-repeat',
//         backgroundPositionX: 'center',
//       },
//     },
//     reachTitle: {
//       fontSize: '10pt',
//       textOverflow: 'ellipsis',
//       whiteSpace: 'nowrap',
//       overflow: 'hidden',
//       textAlign: 'center',
//     },
//     loading: {
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       height: '20vh',
//       width: '100%',
//     },
//     root: { display: 'flex', justifyContent: 'center' },
//     contentIphone: {
//       height: '65vh',
//       width: '15vw',
//       display: 'inline-block',
//       border: `5px solid ${theme.palette.primary.main}`,
//       borderRadius: 25,
//       boxShadow: '0 19px 38px rgb(0 0 0 / 31%), 0 15px 12px rgb(0 0 0 / 22%)',
//       position: 'relative',
//       overflowY: 'overlay',
//     },
//     topbar: {
//       display: 'flex',
//       justifyContent: 'center',
//       position: 'absolute',
//       left: 'calc(22%)',
//       top: -5,
//       width: '56%',
//       backgroundColor: theme.palette.primary.main,
//       height: 12,
//       borderRadius: '0px 0px 15px 15px',
//     },
//     contentTopbar: {
//       backgroundColor: '#000',
//       height: 3,
//       marginTop: 5,
//       width: 30,
//       borderRadius: '20%',
//     },
//     btnVolune: {
//       height: '6vh',
//       listStyle: 'none',
//       borderRadius: '20px 20px 0 0',
//     },
//     contentMobile: {
//       color: theme.palette.primary.main,
//       letterSpacing: -0.8,
//       padding: '1vh 0vw',
//     },
//     avatarMobile: {
//       backgroundColor: theme.palette.primary.main,
//       width: 25,
//       height: 25,
//     },
//     ulComment: {
//       marginLeft: 12,
//       paddingTop: 3,
//       minHeight: 15,
//       fontSize: 12,
//       lineHeight: '12px',
//       color: theme.palette.primary.main,
//       display: 'flex',
//     },
//     liComment: {
//       marginRight: 12,
//     },
//     collapseComment: {
//       maxHeight: '40vh',
//       overflowY: 'auto',
//       overflowX: 'hidden',
//     },
//     rootComment: {
//       boxSizing: 'border-box',
//       wordBreak: 'break-word',
//       wordWrap: 'break-word',
//       whiteSpace: 'normal',
//       borderRadius: 18,
//       backgroundColor: theme.palette.primary.main,
//       color: '#FFF',
//       width: 'fit-content',
//     },
//     nameComment: {
//       color: '#FFF !important',
//       wordBreak: 'break-word',
//       wordWrap: 'break-word',
//       fontWeight: 600,
//       lineHeight: '1.23080',
//       fontSize: '.8125rem',
//     },
//     comment: {
//       wordBreak: 'break-word',
//       wordWrap: 'break-word',
//       maxWidth: '100%',
//       fontWeight: 400,
//       lineHeight: '1.3333',
//       fontSize: '.9375rem',
//     },
//   })
// );
